import React from "react";
import UserAuthService from "../../services/UserAuthService";
import { useNavigate, useSearchParams } from "react-router";
import CircularProgress from "@mui/material/CircularProgress";
import { setDisplayMessage, setDisplayMessageType } from "../../store/XSifterAppReducer";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { debounceUseEffectCallback } from "../../XSifterAppConstants";
import { IResponseBase } from "../../types/XSifterGeneralTypes";

interface IDiscoverTextOAuthLoginProps {

}

const DiscoverTextOAuthLogin: React.FC<IDiscoverTextOAuthLoginProps> = () => {
    const userAuthService = UserAuthService.getInstance();
    const currentUser = useAppSelector((state) => state.app.currentUser);
    const [queryParams, _] = useSearchParams();
    const dispatch = useAppDispatch();    
    const navigate = useNavigate();

    debounceUseEffectCallback(() => {
        userAuthService.setCurrentUser(currentUser);
        if (userAuthService.isLoggedIn()) {
            navigate('/app');
        }

        if (queryParams.get("error")) {
            dispatch(setDisplayMessage(queryParams.get("error")));
            dispatch(setDisplayMessageType("error"))
            navigate('/');
            return
        }

        let code = queryParams.get("code");
        let codeSplit = code?.split(",", 2);
        let hostname = "";
        if (codeSplit?.length === 2)
            hostname = codeSplit[0];
        userAuthService.exchangeCodeForToken(code || "", hostname || "")
        .then(() => {
            navigate("/app");
        }).catch((error: IResponseBase) => {
            dispatch(setDisplayMessage(error.error?.errorMessage ?? "Could not exchange the code for a valid token"));
            dispatch(setDisplayMessageType("error"))
            navigate("/");
        });
    });

    return (
         <CircularProgress aria-label="Loading…" />
    );
}

export default DiscoverTextOAuthLogin;